import React from 'react';

export default function MedalIcon(props) {
  return (
    <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M3 11.4722V17L6.76231 15.4951C6.85012 15.46 6.89402 15.4424 6.93935 15.4354C6.97955 15.4293 7.02045 15.4293 7.06065 15.4354C7.10598 15.4424 7.14988 15.46 7.23769 15.4951L11 17V11.4722M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z" stroke="#5A646E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>


  )
}
